import { type StorageFacade } from "@digits-shared/helpers/storage/storage"

type PreferenceNamespace = Record<string, Record<string, unknown>>

export default class PreferencesStorageCache {
  private namespaceCache = new Map<string, PreferenceNamespace>()

  getValue<T>(
    storage: StorageFacade,
    context: string,
    namespace: string,
    key: string
  ): T | undefined {
    const values = this.getNamespace(storage, namespace)
    return values[context]?.[key] as T | undefined
  }

  setValue(
    storage: StorageFacade,
    context: string,
    namespace: string,
    key: string,
    value: unknown
  ) {
    const values = this.getNamespace(storage, namespace)
    values[context] = values[context] || {}
    values[context][key] = value
    this.setNamespace(storage, namespace, values)
  }

  deleteValue(storage: StorageFacade, context: string, namespace: string, key: string) {
    const values = this.getNamespace(storage, namespace)
    if (!values[context]) return
    delete values[context][key]
    this.setNamespace(storage, namespace, values)
  }

  clearContext(storage: StorageFacade, context: string, namespace: string) {
    const values = this.getNamespace(storage, namespace)
    if (!values[context]) return
    delete values[context]
    this.setNamespace(storage, namespace, values)
  }

  invalidateNamespace(namespace: string) {
    this.namespaceCache.delete(namespace)
  }

  private getNamespace(storage: StorageFacade, namespace: string) {
    const cached = this.namespaceCache.get(namespace)
    if (cached) return cached
    const parsed = JSON.parse(storage.local.getItem(namespace) || "{}") as PreferenceNamespace
    this.namespaceCache.set(namespace, parsed)
    return parsed
  }

  private setNamespace(storage: StorageFacade, namespace: string, values: PreferenceNamespace) {
    this.namespaceCache.set(namespace, values)
    storage.local.setItem(namespace, JSON.stringify(values))
  }
}
